var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItinerary1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.784 10.5735L22.7876 10.5755L15.5013 19.3414L8.21446 10.5755L15.5013 6.548L20.4645 9.20707L28.2061 7.76845L15.5013 0.829376L0.5 9.12205L7.74226 17.8188L7.74329 17.8383L15.5013 27.1706L23.6623 17.3528L21.4714 27.1706H26.4761L30.5 9.13946L22.784 10.5735Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItinerary1);
export default __webpack_public_path__ + "static/media/itinerary-1.67e0d95527b8600f5610bc9ada800439.svg";
export { ForwardRef as ReactComponent };